import React, { Component } from 'react';

export default class Display extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error, errorInfo) {
    console.error('error-display-catch', error);
    this.setState({ error });
  }

  child() {
    const { children, ...props } = this.props;
    if (typeof children === 'function') return children(props);
    return children;
  }

  render() {
    const { error } = this.state;
    if (error) return null;

    return this.props.if ? <>{this.child()}</> : null;
  }
}
